//
//  I13VENTCHAUFFIOULCalcul.js
//
//  Created by Sébastien Hecart on 2017-11-24 13:22:57 +0000.
//  Copyright © 2017 Sebastien Hecart. All rights reserved.
//
import { I13VENTCHAUFFIOUL_State } from '@batical/types/src'

function I13VENTCHAUFFIOUL_docalcul(state: I13VENTCHAUFFIOUL_State) {
  state.invalidated = false
  if (state.in_puissanceTotal > 175) {
    state.res_VH = state.in_puissanceTotal * 0.02
  } else {
    state.res_VH = 3.5
  }
  if (state.in_puissanceTotal > 84) {
    state.res_VB = state.in_puissanceTotal * 0.03
  } else {
    state.res_VB = 2.5
  }
  //=RACINE(C5)*2/PI()*100
  state.res_diamVH = ((Math.sqrt(state.res_VH) * 2) / Math.PI) * 100
  state.res_diamVB = ((Math.sqrt(state.res_VB) * 2) / Math.PI) * 100

  //=RACINE(C5)*100in_puissanceTotal
  state.res_longeurVH = Math.sqrt(state.res_VH) * 100
  state.res_longeurVB = Math.sqrt(state.res_VB) * 100

  //=C5*10000/C14
  state.res_hauteurVH = (state.res_VH * 10000) / state.in_longeurVH
  state.res_largeurVB = (state.res_VB * 10000) / state.in_longeurVB

  return state
}

export default I13VENTCHAUFFIOUL_docalcul
